import { ProCard, ProDescriptions } from '@ant-design/pro-components'
import { localQueryEntityOptions } from '@app/icare/client/db/client/localQueryOneOptions'
import { addressDescriptionItem, contactDescriptionItems } from '@app/icare/components/entity/EntityDescriptionItems'
import { PharmacyEditDrawer } from '@app/icare/routes/_app/apotheken/-components/PharmacyEditDrawer'
import { t } from '@lingui/core/macro'
import { EditSectionButton } from '@pkg/ui/button'
import { TypedDescriptionsItem } from '@pkg/ui/proValueTypes'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { Flex } from 'antd'

export const Route = createFileRoute('/_app/apotheken/$id/')({
  component: RouteComponent,
})

function RouteComponent() {
  const params = Route.useParams()
  const { data } = useQuery(localQueryEntityOptions(params.id))

  if (!data) {
    return <ProCard loading />
  }

  const pharmacy = data

  return (
    <Flex vertical gap="small">
      <ProCard
        headerBordered
        title={t`Allgemein`}
        extra={
          <EditSectionButton
            aria-label={t`Allgemein bearbeiten`}
            onClick={() => void PharmacyEditDrawer.show({ id: data.id, section: 'basic' })}
          />
        }
      >
        <ProDescriptions column={1} size="small" colon={false}>
          <TypedDescriptionsItem label={t`Name`}>{pharmacy.name}</TypedDescriptionsItem>
          {addressDescriptionItem(pharmacy.address)}
          {contactDescriptionItems(pharmacy.contact)}
        </ProDescriptions>
      </ProCard>
      <ProCard
        headerBordered
        title={t`Sonstiges`}
        extra={
          <EditSectionButton
            aria-label={t`Sonstiges bearbeiten`}
            onClick={() => void PharmacyEditDrawer.show({ id: data.id, section: 'misc' })}
          />
        }
      >
        <ProDescriptions column={1} size="small" colon={false}>
          <TypedDescriptionsItem label={t`Bemerkungen`}>{pharmacy.comment}</TypedDescriptionsItem>
          <TypedDescriptionsItem label={t`Sage Bemerkungen`}>{pharmacy.sageComment}</TypedDescriptionsItem>
        </ProDescriptions>
      </ProCard>
    </Flex>
  )
}
